module.exports = __webpack_public_path__ + "img/circle-right-arrow.5833fcb4.svg";